import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { FAQIcon } from 'components/icons-new/faq';

const NotificationsEmpty = () => {
  return (
    <Stack direction='column' alignItems='center' justifyContent='center' gap='20px' padding='30px 0'>
      <FAQIcon />
      <Typography sx={{ fontSize: '14px' }}>Derzeit liegen keine Nachrichten vor.</Typography>
    </Stack>
  );
};

export default NotificationsEmpty;
